import { render, staticRenderFns } from "./treatment-overview-email.vue?vue&type=template&id=726383c9&"
import script from "./treatment-overview-email.vue?vue&type=script&lang=js&"
export * from "./treatment-overview-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports